import i18next from "i18next";
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
// import { links } from '../../data';
import "./navbar.css";
import logo from "../../images/logo.png";
import logo_ar from "../../images/logo_ar.png";
import { FaBars } from "react-icons/fa";
import { FaRegWindowClose } from "react-icons/fa";
import { BsGlobe2 } from "react-icons/bs";
import { default as cookies } from "js-cookie";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const [isNavshowing, setIsNavShowing] = useState(true);
  const [lang, setLang] = useState(false);
  const languages = [
    {
      english: "en",
      code: "en",
    },
    {
      arabic: "ar",
      code: "ar",
    },
  ];
  const langHandler = () => {
    lang
      ? i18next.changeLanguage(languages[0].english.valueOf())
      : i18next.changeLanguage(languages[1].arabic.valueOf());
    lang ? (document.title = "Bilady Group") : (document.title = "معمل بلادي");

    setLang(!lang);
    setIsNavShowing((prev) => !prev);
  };

  const currentLanguageCode = cookies.get("i18next") || "en";
  document.body.dir = currentLanguageCode === "ar" ? "rtl" : "ltr";

  const { t, ready } = useTranslation();
  if (!ready) return "loading translations...";
  const links = t("links", { returnObjects: true });

  return (
    <nav>
      <div className="container nav_container">
        <Link
          to="/home"
          className="logo"
          onClick={() => {
            setIsNavShowing(false);
          }}
        >
          {lang ? (
            <img src={logo_ar} alt="Nav Logo" />
          ) : (
            <img src={logo} alt="Nav Logo" />
          )}
        </Link>
        <ul
          className={`nav__links ${isNavshowing ? "show__nav" : "hide__nav"}`}
        >
          {links.map(({ name, path }, index) => {
            return (
              <li key={index}>
                <NavLink
                  to={path}
                  className={({ isActive }) => (isActive ? "active-nav" : "")}
                  onClick={() => {
                    setIsNavShowing((prev) => !prev);
                  }}
                >
                  {name}
                </NavLink>
              </li>
            );
          })}
          <li className="btn__lang" onClick={langHandler}>
            <BsGlobe2 />
          </li>
        </ul>
        <button
          className="nav__toggle-btn"
          onClick={() => {
            setIsNavShowing((prev) => !prev);
          }}
        >
          {isNavshowing ? <FaRegWindowClose /> : <FaBars />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
